export default [
  {
    title: 'داشبورد',
    route: 'home',
    icon: 'HomeIcon',
    resource: 'LoggedIn',
    action: 'read',
  },
  {
    title: 'تبلیغات',
    route: 'campaigns',
    icon: 'TvIcon',
    resource: 'LoggedIn',
    action: 'read',
  },
  {
    title: 'تبلیغ جدید',
    route: 'campaigns-create',
    icon: 'TvIcon',
    resource: 'LoggedIn',
    action: 'read',
  },
  {
    title: 'اپلیکیشن ها',
    route: 'apps',
    icon: 'FileIcon',
    resource: 'LoggedIn',
    action: 'read',
  },
  {
    title: 'اپلیکیشن جدید',
    route: 'apps-create',
    icon: 'FileIcon',
    resource: 'LoggedIn',
    action: 'read',
  },
]
